

// // taskTrackingReducer.js
// import {
//   FETCH_TASK_TRACKING_REQUEST,
//   FETCH_TASK_TRACKING_SUCCESS,
//   FETCH_TASK_TRACKING_FAILURE,
//   UPDATE_TASK_TRACKING_REMARKS_REQUEST,
//   UPDATE_TASK_TRACKING_REMARKS_SUCCESS,
//   UPDATE_TASK_TRACKING_REMARKS_FAILURE,
// } from "../actions/taskTrackingActions";

// const initialState = {
//   loading: false,
//   taskTrackingData: [],
//   meta: { totalPages: 1, currentPage: 1, total: 0 },
//   error: null,
//   updating: false,
// };

// const taskTrackingReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_TASK_TRACKING_REQUEST:
//       return { ...state, loading: true, error: null };
//     case FETCH_TASK_TRACKING_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         taskTrackingData: action.payload.data,
//         meta: action.payload.meta || {},
//         error: null,
//       };
//     case FETCH_TASK_TRACKING_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     case UPDATE_TASK_TRACKING_REMARKS_REQUEST:
//       return { ...state, updating: true };
//     case UPDATE_TASK_TRACKING_REMARKS_SUCCESS:
//       return { ...state, updating: false };
//     case UPDATE_TASK_TRACKING_REMARKS_FAILURE:
//       return { ...state, updating: false, error: action.payload };

//     default:
//       return state;
//   }
// };

// export default taskTrackingReducer;


import {
  FETCH_TASK_TRACKING_REQUEST,
  FETCH_TASK_TRACKING_SUCCESS,
  FETCH_TASK_TRACKING_FAILURE,
  UPDATE_TASK_TRACKING_REMARKS_REQUEST,
  UPDATE_TASK_TRACKING_REMARKS_SUCCESS,
  UPDATE_TASK_TRACKING_REMARKS_FAILURE,
} from "../actions/taskTrackingActions";

const initialState = {
  loading: false,
  taskTrackingData: [],
  meta: { totalPages: 1, currentPage: 1, total: 0 },
  error: null,
  updating: false,
};

const taskTrackingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TASK_TRACKING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_TASK_TRACKING_SUCCESS:
      return {
        ...state,
        loading: false,
        taskTrackingData: action.payload.data || [],
        meta: {
          totalPages: action.payload.pagination?.totalPages || 1,
          currentPage: action.payload.pagination?.page || 1,
          total: action.payload.pagination?.total || 0,
        },
        error: null,
      };

    case FETCH_TASK_TRACKING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TASK_TRACKING_REMARKS_REQUEST:
      return {
        ...state,
        updating: true,
      };

    case UPDATE_TASK_TRACKING_REMARKS_SUCCESS:
      return {
        ...state,
        updating: false,
      };

    case UPDATE_TASK_TRACKING_REMARKS_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default taskTrackingReducer;
